import identity from 'transmute/identity';
import uniqueId from 'transmute/uniqueId';
import { Map as ImmutableMap } from 'immutable';
// @ts-expect-error file is untyped
import { createAction } from 'flux-actions';
import UserContainer from 'documents-ui/lib/containers/UserContainer';
import getUserView from 'documents-ui/lib/getUserView';
import IndexUIActions from 'SalesContentIndexUI/data/actions/IndexUIActions';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
import { DOCUMENT_CREATE_STARTED, DOCUMENT_CREATE_FAILED, DOCUMENT_CREATE_SUCCEEDED } from 'documents-lib/js/constants/ActionTypes';
import * as UploadApi from 'documents-ui/api/UploadApi';
import { addAlert } from 'documents-lib/js/utils/addAlert';
import documentToSearchResult from 'documents-ui/utils/documentToSearchResult';
const uploadDocumentStarted = createAction(DOCUMENT_CREATE_STARTED, identity);
const uploadDocumentSucceeded = createAction(DOCUMENT_CREATE_SUCCEEDED, identity);
const uploadDocumentFailed = createAction(DOCUMENT_CREATE_FAILED, identity);
const createTempSearchResult = (name, folderId) => {
  const createdAt = new Date().valueOf();
  return SearchResultRecord({
    name,
    createdAt,
    id: uniqueId('document-temp-id-'),
    contentType: SearchContentTypes.DOCUMENT,
    updatedAt: createdAt,
    userId: UserContainer.get().user_id,
    metadata: ImmutableMap({
      numShares: 0,
      numViews: 0,
      progress: 0
    }),
    userView: getUserView(),
    folderId
  });
};
export default (({
  progressionRequest,
  fileName,
  folderId
}) => dispatch => {
  const tempDocument = createTempSearchResult(fileName, folderId);
  const tempId = tempDocument.id;
  dispatch(uploadDocumentStarted(tempId));
  IndexUIActions.addResult(tempDocument);
  const handleUploadProgress = percent => {
    IndexUIActions.updateResult(tempDocument.setIn(['metadata', 'progress'], percent));
  };
  return progressionRequest(handleUploadProgress).then(progressionData => UploadApi.uploadProgressionData(progressionData, handleUploadProgress)).then(documentData => {
    addAlert('uploadFile', 'success', {
      name: documentData.get('title')
    });
    dispatch(uploadDocumentSucceeded(tempId));
    IndexUIActions.replaceResult({
      idToReplace: tempId,
      replacementResult: documentToSearchResult(documentData)
    });
    return documentData;
  }).catch(() => {
    addAlert('uploadFile', 'danger', {
      name: fileName
    });
    dispatch(uploadDocumentFailed(tempId));
    IndexUIActions.removeResult(tempId);
    return null;
  });
});